import _isEmpty from 'lodash/isEmpty';
import Message from '@app/component/message/Message';
import React, { useState } from 'react';
import CompetitorStatIndicatorPortlet
	from '@app/site/secured/review-manager/fragment/property-overview/component/CompetitorStatIndicatorPortlet';
import ReviewsCompetitorOverviewFragment
	from '@app/site/secured/review-manager/fragment/property-overview/_competitors/ReviewsCompetitorOverviewFragment';
import ReviewsStateForPeriod from '@app/model/review/state/ReviewsStateForPeriod';
import CompetitorReviewsState from '@app/model/review/state/CompetitorReviewsState';


const ReviewsCompetitorsOverviewPage: React.FunctionComponent<{
	reviewsStateForPeriod: ReviewsStateForPeriod,
	mainHotelReviewsState: CompetitorReviewsState,
}>
	= ({ reviewsStateForPeriod, mainHotelReviewsState }) => {

	const competitorReviewsStates = reviewsStateForPeriod.findCompetitorStates();

	if (_isEmpty(competitorReviewsStates))
		return <div className="mb-6">
			<Message state="warning">There are no competitor reviews found!</Message>
		</div>;
	else
		return <ReviewsCompetitorsOverview
			mainHotelReviewsState={mainHotelReviewsState}
			competitorReviewsStates={competitorReviewsStates}
		/>;
};

const ReviewsCompetitorsOverview: React.FunctionComponent<{
	mainHotelReviewsState: CompetitorReviewsState,
	competitorReviewsStates: CompetitorReviewsState[]
}>
	= ({ mainHotelReviewsState, competitorReviewsStates }) => {

	const [selectedCompetitorReviewsState, setSelectedCompetitorReviewsState] = useState(competitorReviewsStates[0]);

	const setSelectedHotelId = (hotelId: number) => {
		const nextCompetitorReviewsState = competitorReviewsStates.find(crs => crs.hotelId === hotelId);
		if (nextCompetitorReviewsState) setSelectedCompetitorReviewsState(nextCompetitorReviewsState);
	};

	return <>
		<div className="mb-6">
			<div className="md:hidden">
				<label className="label">Select Competitor</label>
				<div className="mt-0.5">
						<select className="input h-11 w-full" value={selectedCompetitorReviewsState.hotelId}
									onChange={(e) => setSelectedHotelId(Number(e.target.value))}>
							{competitorReviewsStates.map(crs => <option key={crs.hotelId}
																												 value={crs.hotelId}>{crs.hotelName} - {crs.statistics.numberOfReviews} reviews</option>)}
					</select>
				</div>
			</div>
			<div className="hidden md:block">
				<div className="px-3 mb-1">
					<h2 className="text-base font-semibold text-gray-900">Competitive Set</h2>
				</div>
				<div>
					<div className="grid gap-3 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 my-1">
						{competitorReviewsStates.map(crs => <CompetitorStatIndicatorPortlet
							key={crs.hotelId}
							competitorReviewsState={crs}
							isSelected={selectedCompetitorReviewsState.hotelId === crs.hotelId}
							setSelectedHotelId={setSelectedHotelId}
						/>)}
					</div>
				</div>
			</div>
		</div>
		<ReviewsCompetitorOverviewFragment
			mainHotelReviewsState={mainHotelReviewsState}
			competitorReviewsState={selectedCompetitorReviewsState}
		/>

	</>;

};


export default ReviewsCompetitorsOverviewPage;
